const encode = (data) => {
  return reverse(btoa(unescape(encodeURIComponent(JSON.stringify(data))))) + randomString(7)
}
const encodeToken = (data) => {
  data = data + randomString(5)
  return reverse(btoa(unescape(data))) + randomString(10)
}
const encodeRichmenu = (data) => {
  return reverse(btoa(unescape(encodeURIComponent(JSON.stringify(data))))) + randomString(5)
}

const encodeAuthen_news = (data) => {
  return randomString(7) + reverse(btoa(unescape(encodeURIComponent(JSON.stringify(data))))) + randomString(10)
}

function reverse (s) {
  return s.split('').reverse().join('')
}

function randomString (num) {
  var text = ''
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (var i = 0; i < num; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}
const ExpiredDataOnechatToken = () => {
  var today = new Date()
                var dd = String(today.getDate()).padStart(2, '0')
                var hour = String(today.getHours() + 1).padStart(2, '0')
                var minute = String(today.getMinutes()).padStart(2, '0')
                var seconds = String(today.getSeconds()).padStart(2, '0')
                var milsec = today.getMilliseconds()
                var mm = String(today.getMonth() + 1).padStart(2, '0')
                var yyyy = today.getFullYear()
                if (hour === '24') {
                    hour = '00'
                    dd = String(today.getDate() + 1).padStart(2, '0')
                    var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
                    if (parseInt(dd) === date_of_month) {
                        dd = '1'
                        if (mm === '12') {
                            mm = '1'
                            yyyy = today.getFullYear() + 1
                        } else {
                            mm = String(today.getMonth() + 2).padStart(2, '0')
                        }
                    }
                }
                today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
  return Date.parse(today)
}

export default {
  encode,
  encodeToken,
  encodeRichmenu,
  encodeAuthen_news,
  ExpiredDataOnechatToken
}
